import { getValueByPath } from "./helpers";

const messages = {
    wishlist: {
        productAdded: "Item Added to the wishlist",
        productCartAdded: "Added to Cart",
        wishlistEdited: "Wishlist edited",
        wishlistMigrated: "Wishlist migrated",
        wishlistRemoved: "Wishlist removed",
        wishlistShared: "Wishlist shared",
        wishlistCreated: "New wishlist was added",
        copiedToClipboard: "Copied to ClipBoard",
        noCopyToClipboard: "Could not copy to clipboard",
        productRemoved: "Item Removed from the wishlist",
        productExists: "The Product was added to wishlist",
        requestFailed: "The request failed",
        emptyProducts: "You haven’t added anything to this wishlist yet. Start adding your favourite products here!",
        outOfStockInfo: "One of the items is out of stock. You won’t be able to add it to the cart",
        wishlistVariantNotChanged: "Nothing to change",
    },
};

export const getMessage = (path) => {
    return getValueByPath(messages, path);
};
